export enum TaskState {
    Pending = 'PENDING',
    Running = 'RUNNING',
    Error = 'ERROR',
    Success = 'DONE',
    Cancelled = 'CANCELLED',
    Deleted = 'DELETED'
};